import type { SVGProps } from 'react';
import { Ref, forwardRef } from 'react';

interface SVGRProps {
  title?: string;
  titleId?: string;
}

const SvgArrowUpCircleIcon = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g fill="currentColor" fillRule="evenodd" clipRule="evenodd">
      <path d="M22.535 16.54c-.39.39-1.023.39-1.414 0L17 12.41V23a1 1 0 0 1-2 0V12.41l-4.121 4.13a1 1 0 1 1-1.414-1.42l6.536-6.66c.24-.24.568-.31.879-.25.311-.06.639.01.879.25l6.656 6.66c.391.39.391 1.02 0 1.42ZM16 0C7.163 0 0 7.16 0 16s7.163 16 16 16 16-7.16 16-16S24.837 0 16 0Z" />
    </g>
  </svg>
);

const ForwardRef = forwardRef(SvgArrowUpCircleIcon);
export default ForwardRef;
